export const PARTNER_NRC_CATEGORY_ID = 200;
export const PARTNER_RC_CATEGORY_ID = 300;
export const PARTNER_CATEGORY_IDS = [PARTNER_NRC_CATEGORY_ID, PARTNER_RC_CATEGORY_ID];
